import { render, staticRenderFns } from "./blog-list-item.vue?vue&type=template&id=6ca27f58&scoped=true"
import script from "./blog-list-item.vue?vue&type=script&lang=js"
export * from "./blog-list-item.vue?vue&type=script&lang=js"
import style0 from "./blog-list-item.vue?vue&type=style&index=0&id=6ca27f58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca27f58",
  null
  
)

export default component.exports